import { inject } from "@angular/core";
import { CognitoService } from "../services/cognito.service";
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from "@angular/router";
import { OrdersService } from "../services/orders.service";

export const OrderResolver: ResolveFn<any | null> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return inject(OrdersService).fetchOrderByRef(
    route.paramMap.get("referenceNumber")!,
  );
};

export const StoreOrderResolver: ResolveFn<any | null> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return inject(OrdersService).fetchStoreByReferenceId(
    route.paramMap.get("referenceNumber")!,
    route.paramMap.get("action")!,
    route.paramMap.get("storeId")!,
  );
};

export const StoreDraftOrderResolver: ResolveFn<any | null> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return inject(OrdersService).getCurrentStoreReportDraftFromLocalDB(
    route.paramMap.get("referenceNumber")!,
    route.paramMap.get("storeId")!,
  );
};

